import AccountLicenceLogList from './AccountLicenceLogList';

export default [
  {
    key: 'list',
    component: AccountLicenceLogList,
    path: '/account-licence-logs',
    public: false,
  }
];